import React from "react";
import { FormSectionCard } from "./FormSection.styles";
import { Typography } from "antd";
import { CardProps } from "antd/lib/card";

/**
 * Form section component
 * @param {CardProps} props
 */
const FormSection: React.FC<CardProps> = ({ children, title, ...rest }) => {
  return (
    <FormSectionCard
      bordered={false}
      {...rest}
      title={
        <Typography.Title level={3} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
      }
    >
      {children}
    </FormSectionCard>
  );
};

export default FormSection;
